const EDIT_LABEL_FORM = {
  title: {
    text: 'edit_label.title'
  },
  submit: {
    label: 'edit_label.submit_btn'
  },
  fields: [
    {
      name: 'label',
      label: 'edit_label.label_field',
      type: 'text',
      validators: ['required'],
      errors: ['errors.required_label'],
      defaultValue: ''
    }
  ]
}

export default EDIT_LABEL_FORM;
